<template>
  <div class="top-con" v-if="scrollY > (appearPx ?? 30)" @click="gotoTop">
    <v-btn size="x-small" icon color="primary"
      ><v-icon size="x-large" color="white">mdi-arrow-up-circle-outline</v-icon></v-btn
    >
    <span class="top-text">Back To Top</span>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { ref } from "vue";

const props = defineProps<{
  scrollElId: string;
  appearPx?: number;
}>();

const scrollY = ref(0);
const gotoTop = () => {
  const el = document.getElementById(props.scrollElId);
  if (el) {
    el.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    // el.scrollTop = 0;
  }
};

onMounted(() => {
  scrollY.value = document.getElementById(props.scrollElId)?.scrollTop || 0;
  document.getElementById(props.scrollElId)?.addEventListener("scroll", function () {
    scrollY.value = this.scrollTop;
  });
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.top-con {
  position: fixed;
  right: 30px;
  bottom: 30px;
  user-select: none;
  pointer-events: all;
  display: flex;
  flex-direction: column;
  align-items: center;
  .top-text {
    color: $primary;
  }
}
</style>
